import React from 'react';
import { 
  Settings, 
  Users, 
  FileText, 
  Cog, 
  BarChart, 
  Shield,
  Database,
  Mail,
  Bell,
  Crown,
  Lock,
  Eye,
  Edit,
  Trash,
  Plus
} from 'lucide-react';

interface CategoryHeaderProps {
  category: string;
  count: number;
}

const categoryConfig = {
  'general': {
    icon: Settings,
    label: 'General',
    color: 'text-gray-600'
  },
  'admin': {
    icon: Crown,
    label: 'Administración',
    color: 'text-red-700'
  },
  'usuarios': {
    icon: Users,
    label: 'Usuarios',
    color: 'text-blue-600'
  },
  'tramites': {
    icon: FileText,
    label: 'Trámites',
    color: 'text-green-600'
  },
  'sistema': {
    icon: Cog,
    label: 'Sistema',
    color: 'text-purple-600'
  },
  'reportes': {
    icon: BarChart,
    label: 'Reportes',
    color: 'text-orange-600'
  },
  'permisos': {
    icon: Shield,
    label: 'Permisos',
    color: 'text-red-600'
  },
  'database': {
    icon: Database,
    label: 'Base de Datos',
    color: 'text-indigo-600'
  },
  'email': {
    icon: Mail,
    label: 'Email',
    color: 'text-pink-600'
  },
  'notifications': {
    icon: Bell,
    label: 'Notificaciones',
    color: 'text-yellow-600'
  },
  'security': {
    icon: Lock,
    label: 'Seguridad',
    color: 'text-red-800'
  },
  'view': {
    icon: Eye,
    label: 'Vista',
    color: 'text-teal-600'
  },
  'edit': {
    icon: Edit,
    label: 'Edición',
    color: 'text-amber-600'
  },
  'delete': {
    icon: Trash,
    label: 'Eliminación',
    color: 'text-red-500'
  },
  'create': {
    icon: Plus,
    label: 'Creación',
    color: 'text-green-500'
  }
};

export const CategoryHeader: React.FC<CategoryHeaderProps> = ({ category, count }) => {
  const config = categoryConfig[category as keyof typeof categoryConfig];
  
  // Si no encontramos la categoría, creamos una configuración dinámica
  const finalConfig = config || {
    icon: Settings,
    label: category.charAt(0).toUpperCase() + category.slice(1), // Capitalizar primera letra
    color: 'text-slate-600' // Color neutral para categorías desconocidas
  };
  
  const IconComponent = finalConfig.icon;

  return (
    <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-200">
      <div className={`p-2 rounded-lg bg-gray-50 ${finalConfig.color}`}>
        <IconComponent className="w-5 h-5" />
      </div>
      <div className="flex-1">
        <h3 className="text-lg font-semibold text-gray-900">
          {finalConfig.label}
        </h3>
        <p className="text-sm text-muted-foreground">
          {count} {count === 1 ? 'permiso' : 'permisos'}
        </p>
      </div>
    </div>
  );
};